import { CSSProperties, memo } from 'react';

export type ProgressBarProps = {
  current: number;
  total: number;
  width?: string;
  height?: string;
  borderRadius?: string;
  backgroundColor?: string;
  fillColor?: string;
  textColor?: string;
  style?: CSSProperties;
};

export const ProgressBar = memo(
  ({
    current,
    total,
    width = '100%',
    height = '16px',
    borderRadius = '8px',
    backgroundColor = '#ffffff80',
    fillColor = '#34B9AE',
    textColor,
    style,
  }: ProgressBarProps) => {
    const percentage = (current / total) * 100;

    return (
      <div
        style={{
          position: 'relative',
          width: width,
          backgroundColor: backgroundColor,
          borderRadius: borderRadius,
          overflow: 'hidden',
          ...style,
        }}
      >
        <div
          style={{
            width: `${percentage}%`,
            backgroundColor: fillColor,
            height: height,
            transition: 'width 0.3s ease',
          }}
        />
        {textColor && (
          <span
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: height,
              textAlign: 'center',
              color: textColor,
              lineHeight: height,
              fontSize: `calc(${height} * 0.8)`,
              WebkitTextStroke: `4px ${fillColor}`,
              paintOrder: 'stroke fill',
            }}
          >
            {current}/{total}
          </span>
        )}
      </div>
    );
  },
);
